import React from 'react';
import { ToolOutlined } from '@ant-design/icons';
import { STEP_TYPE } from '../../constants';
import { ReactSVG } from 'react-svg';
import { useSelector } from 'react-redux';
import { selectAllOrders } from '../../modules/orders/stores/slice';
import { isSameSelectedStep } from '../../utils/multiSelect';

const StepContent = ({
  step,
  indexStep,
  stepPopover,
  onClickStep,
  widthDuration,
  driverId,
  selectedMultipleSteps,
  multipleStepState,
  selectedStep,
  selectable = false,
  isLate = false,
  isEarly = false,
}) => {
  const orders = useSelector(selectAllOrders);
  const isMultipleSelected = multipleStepState?.steps?.find((item) => isSameSelectedStep(item, step, driverId));
  const color = step.color;

  const style = {
    borderColor: color,
    color: color,
    width: widthDuration,
    minWidth: 'max-content',
    borderWidth: isMultipleSelected || selectedStep?.id === step.id ? '3px' : '1px',
    zIndex: 10,
  };

  if (Number(indexStep) >= 10) style.letterSpacing = '-1px';

  if (step.status === 'COMPLETED') {
    if (step.type === STEP_TYPE.pickup && step.status === 'COMPLETED') {
      const orderIds = step.orderIds || [];
      const isCompleted = orderIds.some((id) => {
        const order = orders.find((o) => o.id === id);
        return order && order.pickupStatus === 'COLLECTED';
      });
      style.color = 'white';

      if (isCompleted) {
        style.backgroundColor = '#437444';
        style.borderColor = '#437444';
      } else {
        style.backgroundColor = '#b03030';
        style.borderColor = '#b03030';
      }
    } else if (step.type === STEP_TYPE.delivery && step.status === 'COMPLETED') {
      // For delivery, check if any order in orderIds is completed
      const orderIds = step.orderIds || (step.orderId ? [step.orderId] : []);
      const isCompleted = orderIds.some((id) => {
        const order = orders.find((o) => o.id === id);
        return order && order.status === 'COMPLETED';
      });
      style.color = 'white';
      if (isCompleted) {
        style.backgroundColor = '#437444';
        style.borderColor = '#437444';
      } else {
        style.backgroundColor = '#b03030';
        style.borderColor = '#b03030';
      }
    }
  }

  // Time window violation styling
  if (step.status !== 'COMPLETED' && (isLate || isEarly)) {
    style.borderColor = isLate ? '#d32f2f' : '#ed6c02';
    style.backgroundColor = isLate ? '#ffebee' : '#fff3e0';
    style.color = isLate ? '#d32f2f' : '#ed6c02';
  }

  const newClickStep = (e, step) => {
    if ((e.ctrlKey || e.metaKey || e.shiftKey) && selectedMultipleSteps) {
      selectedMultipleSteps && selectedMultipleSteps(step, driverId);
    } else {
      onClickStep(step);
    }
  };
  const isService = step.type.toLowerCase() === 'service';
  return (
    <div
      className={`${
        step.type.toLowerCase() === 'pickup' ? 'unit' : isService ? 'unit unit2 unit-service' : 'unit unit2'
      } ${stepPopover}`}
      style={style}
      onClick={(e) => newClickStep(e, step)}
      // Rubber-band multi-select — the day-plan resolves hits back to their
      // step via this attribute. Only LIVE badges are selectable (the planned
      // reference row is read-only).
      {...(selectable && driverId != null ? { 'data-ms-step': `${driverId}|${step.stepId}|${step.type}` } : {})}
    >
      {step.index}
      {(isLate || isEarly) && step.status !== 'COMPLETED' && (
        <span className="anticon">
          <ReactSVG src={`${process.env.PUBLIC_URL || ''}/icons/late.svg`} />
        </span>
      )}
      {/* SERVICE marker — tool glyph so a single-visit service task reads
          differently from a delivery on the timeline. The late/early icon
          keeps priority on the same corner slot. */}
      {isService && !((isLate || isEarly) && step.status !== 'COMPLETED') && <ToolOutlined />}
    </div>
  );
};

export default StepContent;
